import { Component, EventEmitter, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { ApiService } from 'src/app/pages/common/api.service';



@Component({
  selector: 'app-not-eligible-modal',
  templateUrl: './not-eligible-modal.component.html',
  styleUrls: ['./not-eligible-modal.component.scss'],
  providers: [ApiService]
})
export class NotEligibleModalComponent implements OnInit {

  timerToShow = 10;
  constructor(public GlobalConstants: GlobalConstants,
    private _apiService: ApiService,
    private toastr: ToastrService,
    public _bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    // this.countDown(10, () => {
    //   window.location.href = "/";
    // });
  }

  int: any;
  countDown(i, callback) {
    callback = callback || function () { };
    this.int = setInterval(() => {
      const minutes: number = Math.floor(i / 60);
      this.timerToShow =  (i - minutes * 60);

      i-- || (clearInterval(this.int), callback());
    }, 1000);
  }


}
